/**
 * @fileoverview Построение маршрутов руления по перрону / РД.
 */

import { TAXI_Y } from "../constants/world";
import type { Point } from "../state/types";
import { dist } from "../util/math";

/**
 * Маршрут от `from` к `to`.
 * При `viaTaxi` сначала выходит на главную РД (`TAXI_Y`), затем к цели.
 * Близкие дубликаты точек отбрасываются — иначе дрожь у гейта.
 */
export function pathTo(from: Point, to: Point, viaTaxi = false): Point[] {
  const pts: Point[] = [];
  if (viaTaxi) {
    if (Math.abs(from.y - TAXI_Y) > 8) pts.push({ x: from.x, y: TAXI_Y });
    if (Math.abs(to.x - from.x) > 8) pts.push({ x: to.x, y: TAXI_Y });
  }
  pts.push({ x: to.x, y: to.y });

  const out: Point[] = [];
  for (const w of pts) {
    const last = out[out.length - 1];
    if (!last || dist(last.x, last.y, w.x, w.y) > 10) out.push(w);
  }
  // Всегда хотя бы точка назначения — иначе taxi_gate мгновенно становится service
  if (!out.length) out.push({ x: to.x, y: to.y });
  return out;
}
